import { AcademicTermProgramArray } from '@/queries/scholarship-award-history/schema'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shad/ui/select'

type Props = {
  academicTerms: AcademicTermProgramArray
  value: string
  onValueChange: (value: string) => void
}

export function AcademicTermsFilter({
  academicTerms,
  value,
  onValueChange,
}: Props) {
  return (
    <div className="w-48">
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select an academic term" />
        </SelectTrigger>
        <SelectContent>
          {academicTerms.map((term) => (
            <SelectItem key={term.id} value={term.id.toString()}>
              {term.purse_name ? `${term.purse_name} - ` : ''}
              {term.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
